import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { FrsReleaseHelper } from '../services/frs.release.helper.service';
import { FrsReleaseService } from '../services/frs.release.service';
import { PackageModelService } from '../services/frs.package.model.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { UserService } from '../../../core/services/core.user.service';
import { GfTitleService } from '../../../core/services/core.title.service';

import * as _ from 'lodash';

@Component({
    selector: 'frs-roadmap',
    template: `<div class="row fade-show-hide">
    <div class="col-xs-12">
        <h1 class="page-header">
            <project-heading-dropdown [projectMenu]="projectMenu"></project-heading-dropdown>
            <span>{{projectMenu.projectName}}</span>
            <small translate>Roadmap</small>
        </h1>

        <breadcrumbs [crumbs]="breadcrumbs"></breadcrumbs>
    </div>
</div>

<div class="row">
    <div class="col-xs-12">
        <frs-tabs></frs-tabs>

        <gf-spinner *ngIf="!releases"></gf-spinner>

        <div role="tabpanel" class="tab-pane active" id="roadmap-tab" style="padding-top: .5em;">
            <div *ngIf="releases">
                <h3 style="margin-bottom: 1em; padding-left: .25em;" translate>Click to see release details</h3>
                <ul class="list-group col-xs-12" style="max-width: 1200px;">

                    <ng-container *ngFor="let release of releases">
                        <a id="relRoadDet"
                            class="list-group-item" style="padding: 1.5em 1em;"
                            uiSref="home.project.summary.frs.details" [uiParams]="{ releaseId: release.id, unixName: unixName }" [uiOptions]="{ inherit: false }">
                            <h3 id="relRoadname" class="list-group-title" style="margin: .5em;">{{release.package.packageName}}::{{release.releaseName}}
                                <span class="pull-right">
                                    <span *ngIf="release.isReleased == 'N'" style="margin-left: 1em;" class="label label-danger" translate>Not Released</span>
                                    <span *ngIf="release.isReleased == 'Y'" style="margin-left: 1em;" class="label label-success" translate>Released</span>
                                    <span *ngIf="release.package.isPublic == 'N'" class="label label-warning" translate>Private</span>
                                    <span *ngIf="release.package.isPublic == 'Y'" class="label label-success" translate>Public</span>
                                    <span *ngIf="release.rel?.trove?.length"
                                        class="label label-info">
                                        {{release.rel?.trove[0]?.categoryName}}
                                    </span>
                                </span>
                            </h3>
                            <p id="relRoadDateandBar" class="list-group-item-text" style="margin: .5em;">
                                <span translate>Planned Release</span>: {{release.releaseDate | gfDate}}
                                <frs-progress-bar [release]="release"></frs-progress-bar>
                            </p>
                        </a>
                    </ng-container>
                </ul>
                <div *ngIf="releases.length===0" translate>There are no unreleased releases</div>
            </div>
        </div>
    </div>
</div>`
})
export class FrsRoadmapComponent implements OnInit {

    @Input() projectMenu: any = null;

    protected releases: any = false;
    private loading = true;
    protected breadcrumbs = [];

    // `inherit: false` on the release links drops every ancestor param, so the
    // project unixName has to be passed explicitly or the details URL is built
    // with an empty project segment.
    unixName = '';

    constructor(
        private window: Window, 
        private stateService: StateService,
        private frsReleaseHelper: FrsReleaseHelper,
        private frsReleaseService: FrsReleaseService,
        private packageModel: PackageModelService,
        private gfTranslateService: GfTranslateService,
        private userService: UserService,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.releases = false;
        this.loading = true;
        this.titleService.setTitle(this.projectMenu.projectName, 'Roadmap');

        this.breadcrumbs = [
            {
                label: this.projectMenu.projectName,
                state: 'home.project.summary',
                params: { unixName: this.projectMenu.unixName }
            },
            {
                label: this.gfTranslateService.translate('Releases'),
                state: 'home.project.summary.frs',
                params: { unixName: this.projectMenu.unixName }
            },
            {
                label: this.gfTranslateService.translate('Roadmap')
            }
        ];

        const stateParams = this.stateService.params;
        this.unixName = _.get(stateParams, 'unixName', '');
        this.packageModel.setAcl(
            this.userService.session.getUnixName(),
            this.unixName
        );

        this.frsReleaseService.getRoadmap(stateParams.unixName)
            .then((response: any) => {
                this.loading = false;
                this.releases = _.get(response, 'items', []);
            });
    }

};